module.exports = __webpack_public_path__ + "static/media/212-Sturz-Ansprechen-Teil2-Milo_ID_12.665fc76f.mp3";